import { ContactsContext } from "ContactsContext";

import React, { useContext } from "react";
import axios from "axios";
import { Dropdown } from "react-bootstrap";
import { MoreOptionsDropdownButton } from "MoreOptionsDropdown";
import { useConfirmation } from "ConfirmationDialog";
import { toast } from "ToastAlertContainer";

import "MoreOptionsDropdown/styles.scss";

const PostCardOptionsButton = ({ postId, company }) => {
  const handleMoreOptionSelect = async (eventKey, postId) => {
    switch (eventKey) {
      case "VIEW_ANALYTICS":
        window.location.href = `/${company.name}/composer/${postId}`;
        break;
      case "COPY_AND_EDIT":
        let result;
        try {
          result = await axios.post(
            "/api/v2/companies/" +
              company.company_id +
              "/posts/" +
              postId +
              "/duplicate"
          );
        } catch (err) {
          console.error(err.response.message);
          toast.error("There was an issue while duplicating this post");
          return;
        }

        window.location.href = `/${company.name}/composer/${result.data.post_id}`;
        break;
      default:
        break;
    }
  };

  return (
    <div className="">
      <Dropdown drop="left">
        <Dropdown.Toggle key={postId} as={MoreOptionsDropdownButton} />

        <Dropdown.Menu className="ps-more-options-menu">
          <Dropdown.Item
            eventKey="VIEW_ANALYTICS"
            onClick={(eventKey) =>
              handleMoreOptionSelect("VIEW_ANALYTICS", postId)
            }
          >
            View Analytics
          </Dropdown.Item>
          <Dropdown.Item
            eventKey="COPY_AND_EDIT"
            onClick={(eventKey) =>
              handleMoreOptionSelect("COPY_AND_EDIT", postId)
            }
          >
            Duplicate Update
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default PostCardOptionsButton;
